import { Download, Search } from "lucide-react";
import * as React from "react";
import ExportButton from "./useBenefitExcelExport";

export default function BenefitFilterSection({
  searchTerm,
  setSearchTerm,
  filterBySearchTerm,
}) {
  const [selectedPeriod] = React.useState("month");

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 items-center">
      <div className="relative">
        <Search className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
        <input
          type="text"
          placeholder="Search by category, remarks, or amount..."
          className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-transparent text-foreground bg-background"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <ExportButton
        data={filterBySearchTerm}
        selectedPeriod={selectedPeriod}
        icon={<Download className="w-5 h-5" />}
      />
    </div>
  );
}
